export const EVENT_API_URL = 'https://api-serv.phuket.psu.ac.th'
export const TIME_ATTENDANCE_API_URL = 'https://api-serv.phuket.psu.ac.th'
//export const TIME_ATTENDANCE_API_URL='http://localhost:8000'

export const TIME_ATTENDANCE_EVENT_API_URL = 'https://api-serv.phuket.psu.ac.th'
export const APPLICATION_ID = 'p$upkt4@ndr01d'
export const APPLICATION_NAME = 'TimeAttendanceWebSelfRegistration'

export const JWT_SECRET ='nitiwat.t'
